// Module
var code = "<title>Account Settings</title> <div class=\"h100\" ng-controller=\"AdminPanelCtrl\" ng-cloak> <vue-component class=\"h100\" name=\"AdminRouterWrapper\" router=\"router\"/> </div> ";
// Exports
module.exports = code;